import * as React from "react";
import { Store } from "./store";
import { observer } from "mobx-react";
import {
	TopWrapper,
	TopButton,
} from "./components";
import { DropDownList } from "../../elements/dropdown.list/index";
import { Tooltip } from "../../tooltip/index";
import { FaSync, FaDownload } from "react-icons/fa";

interface Props<T> {
	store: Store<T>;
	showExportModule?: boolean;
}

@observer
export class ProtableTopBar<T> extends React.Component<Props<T>> {

	constructor(props: Props<T>) {
		super(props);
		this.state = {};
	}

	render() {
		const { store, showExportModule } = this.props;
		const s = store.s;
		return (
			<TopWrapper>
				<TopButton
					className="text-left"
					onClick={() =>
						store.update({
							dropdown: s.dropdown === "filters" ? "" : "filters",
						})
					}
				>
					Filters
				</TopButton>

				<DropDownList
					onSelect={(selected) => {
						store.update({ limit: selected.value as number });
						store.fetch();
					}}
					options={[
						{ label: "10 Results", value: 10 },
						{ label: "25 Results", value: 25 },
						{ label: "50 Results", value: 50 },
					]}
				>
					<TopButton className="max128 width128">
						{s.limit} Results
					</TopButton>
				</DropDownList>

				<Tooltip text="Refresh" width={65} position="top">
					<TopButton className="max48" onClick={store.fetch}>
						<FaSync />
					</TopButton>
				</Tooltip>

				{showExportModule && (
					<Tooltip text="Export" width={65} position="top">
						<TopButton
							className="max48"
							onClick={() =>
								store.update({
									dropdown:
										s.dropdown === "export" ? "" : "export",
								})
							}
						>
							<FaDownload />
						</TopButton>
					</Tooltip>
				)}
			</TopWrapper>
		);
	}
}
